import React from 'react';
import { useSelector } from 'react-redux';

import { getCurrentAppointmentDate } from 'features/order-tracker/store/selectors';
import { CalendarIcon } from 'features/order-tracker/shared-components/svg';
import { SectionHeader } from '../../../components';
import {
  TITLE,
  SUB_TITLE,
  APPOINTMENT_INFO_TITLE,
} from './constants';

import styles from './styles.module.scss';

export const AppointmentDetails: React.FC = () => {
  const currentAppointmentDate = useSelector(getCurrentAppointmentDate);

  return (
    <>
      <SectionHeader
        title={TITLE}
        subtitle={SUB_TITLE}
      />
      <div className={styles.appointmentInfoContainer}>
        <CalendarIcon className={styles.calendarIcon} />
        <div className={styles.appointmentInfo}>
          <p>{APPOINTMENT_INFO_TITLE}</p>
          <h5>{currentAppointmentDate}</h5>
        </div>
      </div>
    </>
  );
};
